if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.bmsmWidget = this.querySelector('[data-dfc-bmsm]');
			if ( this.bmsmWidget ) {
				this.initBmsmNavigationPosition();
			}

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						const nativeCartOpened = document.getElementById('site-cart-sidebar').show();
						if ( nativeCartOpened !== false && document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							if ( nativeCartOpened !== false ) {
								setTimeout(()=>{
									document.querySelector('#site-cart-sidebar [data-js-close]').focus();
									addToCartEnter = false;
								}, 200);
							} else {
								window.lastFocusedElm = null;
								addToCartEnter = false;
							}
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		initBmsmNavigationPosition(){

			const storageKey = 'dfc-bmsm-navigation-position';
			const maxAge = 10000;
			const clearNavigationState = ()=>{
				try {
					sessionStorage.removeItem(storageKey);
				} catch ( error ) {
					// Product navigation still works when browser storage is unavailable.
				}
				document.documentElement.classList.remove('dfc-bmsm-navigation-pending');
				if ( window.dfcBmsmNavigationOverlayTimeout ) {
					window.clearTimeout(window.dfcBmsmNavigationOverlayTimeout);
					window.dfcBmsmNavigationOverlayTimeout = null;
				}
			};
			const showNavigationOverlay = ()=>{
				document.documentElement.classList.add('dfc-bmsm-navigation-pending');
				window.clearTimeout(window.dfcBmsmNavigationOverlayTimeout);
				window.dfcBmsmNavigationOverlayTimeout = window.setTimeout(clearNavigationState, maxAge);
			};

			this.bmsmWidget.addEventListener('click', event=>{
				if ( ! ( event.target instanceof Element ) ) return;

				const link = event.target.closest('[data-dfc-bmsm-pack-link]');
				if (
					! link
					|| event.defaultPrevented
					|| event.button !== 0
					|| event.metaKey
					|| event.ctrlKey
					|| event.shiftKey
					|| event.altKey
					|| ( link.target && link.target !== '_self' )
				) return;

				const destination = new URL(link.href, window.location.href);
				if ( destination.origin !== window.location.origin || destination.pathname === window.location.pathname ) return;

				let handoffStored = false;
				try {
					sessionStorage.setItem(storageKey, JSON.stringify({
						destination: destination.pathname,
						top: this.bmsmWidget.getBoundingClientRect().top,
						createdAt: Date.now()
					}));
					handoffStored = true;
				} catch ( error ) {
					// Keep the product link usable without position restoration.
				}

				if ( ! handoffStored ) return;

				event.preventDefault();
				showNavigationOverlay();
				requestAnimationFrame(()=>{
					requestAnimationFrame(()=>window.location.assign(destination.href));
				});
			});

			let storedPosition;
			try {
				storedPosition = JSON.parse(sessionStorage.getItem(storageKey));
			} catch ( error ) {
				clearNavigationState();
				return;
			}

			if ( ! storedPosition ) return;

			if (
				storedPosition.destination !== window.location.pathname
				|| ! Number.isFinite(storedPosition.top)
				|| ! Number.isFinite(storedPosition.createdAt)
				|| Date.now() - storedPosition.createdAt > maxAge
			) {
				clearNavigationState();
				return;
			}

			let stableFrames = 0;
			let pageLoaded = document.readyState === 'complete';
			if ( ! pageLoaded ) window.addEventListener('load', ()=>{ pageLoaded = true; }, { once: true });

			const maintainPosition = ()=>{
				if ( Date.now() - storedPosition.createdAt > maxAge ) {
					clearNavigationState();
					return;
				}

				if ( getComputedStyle(this.bmsmWidget).display === 'none' ) {
					requestAnimationFrame(maintainPosition);
					return;
				}

				const offset = this.bmsmWidget.getBoundingClientRect().top - storedPosition.top;
				if ( Math.abs(offset) > 0.5 ) {
					window.scrollBy({ top: offset, left: 0, behavior: 'instant' });
					stableFrames = 0;
				} else {
					stableFrames += 1;
				}

				if (
					pageLoaded
					&& stableFrames >= 4
				) {
					clearNavigationState();
					return;
				}

				requestAnimationFrame(maintainPosition);
			};

			maintainPosition();

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
			
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
